import "drag-drop-touch"

import * as Sentry from "@sentry/react"
import { ActionAlertProvider, ToastProvider } from "@suraasa/placebo-ui"
import { theme } from "@suraasa/placebo-ui-legacy"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { APIError } from "api/utils"
// import SlidingSheet from "components/SlidingSheet"
// import CaptchaTest from "components/CaptchaTest"
import { PageWithMeta } from "components/Metadata"
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import AssignmentResult from "features/AssignmentResult"
import Authentication from "features/Authentication"
import LearningModule from "features/LearningModule"
// import DeviceInfo from "DeviceInfo"
// import Leaderboard from "features/LearningItems/Qualification/Leaderboard"
import CpatProctoringTest from "features/Misc/CpatProctoringTest"
import FillBlanksTest from "features/Misc/FillBlanksTest"
import PosthogTest from "features/Misc/PosthogTest"
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
// import Profile from "features/Profile"
const Profile = safeLazyImport(() => import("features/Profile"))
// import ProctoringDemo from "features/Misc/ProctoringDemo"
// import HassleFreePaymentPlan from "features/Orders/OrderDetails/Payments/HassleFreePlan"
import SkillProfile from "features/SkillProfile"
import GlobalContext from "global/Context"
import PostHogProviderWrapper from "global/PostHogProviderWrapper"
import React, { Suspense } from "react"
import { ThemeProvider } from "react-jss"
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  Navigate,
  RouterProvider,
  useLocation,
  useNavigationType,
  useParams,
} from "react-router-dom"
import routes from "routes"

import Home from "./features/Home"
import AppLayout from "./layout/AppLayout"
import { useDOMDirection } from "./utils/hooks/useDOMDirection"
const Schedule = safeLazyImport(() => import("features/Schedule"))
const Assignments = safeLazyImport(() => import("features/Assignments"))
const ITO = safeLazyImport(() => import("features/ITO/Reports"))
// import SlidingSheet from "components/SlidingSheet"
// import CaptchaTest from "components/CaptchaTest"
import { ToolType } from "api/resources/aiTools/types"
import SuraasaSureHome from "B2B/SuraasaSure/Features/Home"
import SuraasaSureSettings from "B2B/SuraasaSure/Features/Settings"
import SuraasaSureAppLayout from "B2B/SuraasaSure/Layout/AppLayout"
import ErrorPage from "components/ErrorPage"
import Redirect from "components/Redirect"
import AItools from "features/AItools"
import Generator from "features/AItools/components/Generator"
import ScheduleInterview from "features/ApplicationForm/ApplicationFormStatusBanners/Pgctl/ScheduleInterview"
import UploadDocuments from "features/ApplicationForm/UploadDocuments"
import AttemptAssessment from "features/Assessments/Attempt/"
import AssessmentResult from "features/Assessments/Result"
import { AuthManager } from "features/Authentication/AuthManager"
import AuthManagerProvider from "features/Authentication/AuthManagerProvider"
import { Logout } from "features/Authentication/Logout"
import { PrivateRoutes } from "features/Authentication/PrivateRoutes"
import CPATOverview from "features/Cpat"
import CpatAssessmentWrapper from "features/Cpat/Assessments/Attempt/Wrapper"
import CpatPaymentPage from "features/Cpat/PaymentWithoutSignin/Payment/PaymentForm"
import CpatProctoringReport from "features/Cpat/ProctoringReport"
import DiscussionDetailPage from "features/Discussions/DiscussionDetailPage"
import EmbeddedGoogleForm from "features/EmbeddedGoogleForm"
import GsgCPAT from "features/GsgCpat"
import CpatAssessmentTour from "features/Home/SuraasaPlusNewYearOnboarding/CpatAssessmentTour"
// import GsgCPAT from "features/GsgCpat"
// import DeviceInfo from "DeviceInfo"
import ITOAssessmentWrapper from "features/ITO/Assessments/Attempt/Wrapper"
import AssessmentInstructions from "features/ITO/Assessments/Instructions"
// import Dashboard from "features/ITO/Dashboard"
const Dashboard = safeLazyImport(() => import("features/ITO/Dashboard"))
import LearnerHandbook from "features/LearnerHandbook"
import LearnerAnalytics from "features/LearningItems/Analytics"
import CourseAssessments from "features/LearningItems/Course/Assessments"
import CourseAbout from "features/LearningItems/Course/CourseAbout"
import GradeBook from "features/LearningItems/Qualification/Gradebook"
import QualificationAbout from "features/LearningItems/Qualification/QualificationAbout"
// import Leaderboard from "features/LearningItems/Qualification/Leaderboard"
import QualificationClasses from "features/LearningItems/Qualification/QualificationClasses"
import { AdditionalResources } from "features/LearningItems/Resources"
import MaintenanceMode from "features/Maintenance"
import MasterclassesPage from "features/Masterclasses"
import ViewMasterclass from "features/Masterclasses/ViewMasterclass"
import SentryErrorTesting from "features/Misc/SentryErrorTesting"
import MyCertificates from "features/MyCertificates"
import Orders from "features/Orders"
import OrderDetails from "features/Orders/OrderDetails"
import Payment from "features/Payment"
import CartlessPaymentFlow from "features/Payment/CartlessPaymentFlow"
import CartlessSubscriptionFlow from "features/Payment/CartlessSubscriptionFlow"
import EmbeddedPayment from "features/Payment/EmbeddedPayment"
import RetryPaymentPage from "features/Payment/RetryPaymentPage"
import PgctlPaymentPage from "features/PgctlOnboarding/Payment/PaymentForm"
// import ProctoringDemo from "features/Misc/ProctoringDemo"
// import PublicProfile from "features/Profile/PublicProfile"
const PublicProfile = safeLazyImport(
  () => import("features/Profile/PublicProfile")
)
// import HassleFreePaymentPlan from "features/Orders/OrderDetails/Payments/HassleFreePlan"
import FullPageLoading from "components/FullPageLoading"
import Settings from "features/Settings"
import AccountDetails from "features/Settings/AccountDetails"
import NotificationSettings from "features/Settings/NotificationSettings"
import Privacy from "features/Settings/Privacy"
import SettingsRouteElement from "features/Settings/SettingsRouteElement"
import CleverCallback from "features/Settings/SocialAccounts/CleverCallback"
import SuraasaPlusSettings from "features/Settings/SuraasaPlusSettings"
import CompareFeatures from "features/Settings/SuraasaPlusSettings/CompareFeatures"
import PaymentHistory from "features/Settings/SuraasaPlusSettings/PaymentHistory"
import SignUpOnboarding from "features/SignupOnboarding"
import StudentCatalog from "features/StudentCatalog"
import SuraasaPlusPayment from "features/SuraasaPlus/Payment"
import SuraasaPlusPaymentSuccessPage from "features/SuraasaPlus/Payment/SuccessPage"
import TIA from "features/TIA"
import ClaimSuraasaPlusPage from "features/WorldTeachersMonth/ClaimSuraasaPlusPage"
import GrowthspaceRoute from "growthspace/GrowthspaceRoute"
import { safeLazyImport } from "safeImport"
import { SmartBanner } from "SmartBanner"
import {
  CPAT_PRODUCT_SLUG,
  IS_DEV_ENVIRONMENT,
  IS_LOCALHOST,
  IS_PROD_ENVIRONMENT,
  Platforms,
} from "utils/constants"

import Discussions from "./features/Discussions"
import Course from "./features/LearningItems/Course"
import CourseAssignments from "./features/LearningItems/Course/Assignments"
import CourseClassesRoute from "./features/LearningItems/Course/Classes/CourseClassesRoute"
import CourseOverview from "./features/LearningItems/Course/Overview"
import Qualification from "./features/LearningItems/Qualification"
import QualificationAssessments from "./features/LearningItems/Qualification/Assessments"
import QualificationCertificates from "./features/LearningItems/Qualification/Certificates"
import QualificationOverview from "./features/LearningItems/Qualification/QualificationOverview"
import Library from "./features/Library"
import Notifications from "./features/Notifications"

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

const getSentryEnvironment = () => {
  if (IS_LOCALHOST) return "localhost"
  if (IS_DEV_ENVIRONMENT) return "development"
  if (IS_PROD_ENVIRONMENT) return "production"

  return "unknown"
}

if (SENTRY_DSN) {
  Sentry.init({
    environment: getSentryEnvironment(),
    ignoreErrors: [
      // Can't fix this
      "Failed to get document because the client is offline",
      "The play() request was interrupted by a call to pause()",
      "Error: The Google Maps JavaScript API could not load.",
      // Firebase abort errors when component unmounts before fetch completes
      "AbortError",
      "Fetch is aborted",
    ],
    release: "suraasa-lms-web@" + APP_VERSION,
    dsn: SENTRY_DSN,
    tracesSampleRate: 0,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[500, 599]],
        // Only capture errors from our own backend. This ignores errors from domains like:
        // https://suraasa-dev-cdn.azureedge.net
        // https://firebaseinstallations.googleapis.com
        failedRequestTargets: [/https:\/\/proxima\.suraasa\.com\/.*/],
      }),
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    sendDefaultPii: true,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 0.5,

    beforeSend(event, hint) {
      // console.log("> Logging event on Sentry", event, hint)

      // Ignore errors from froala-editor
      if (event.exception?.values) {
        const hasFroalaError = event.exception.values.some(exception => {
          return exception.stacktrace?.frames?.some(frame => {
            return (
              frame.filename?.includes("froala-editor") ||
              frame.filename?.includes("froala_editor")
            )
          })
        })

        if (hasFroalaError) {
          console.log("> Dropping froala-editor error", event)
          return null
        }
      }

      const requestUrl = event.request?.url
      if (requestUrl) {
        try {
          const url = new URL(requestUrl)
          const pathname = url.pathname

          // Ignore 500 errors from norma because they are very frequent and don't affect the user anyway.
          if (pathname.startsWith("/norma")) {
            console.log("> Dropping event", event)
            return null
          }
        } catch (_) {
          // Ignore error
        }
      }

      // Hydrating APIErrors with more information so it's easier to debug on Sentry Dashboard
      if (event.exception?.values && event.exception.values.length > 0) {
        const exception = event.exception.values[0]
        if (exception?.type === "APIError") {
          const originalException = hint.originalException as APIError
          event.tags = {
            ...event.tags,
            "api.status_code": originalException.statusCode?.toString() ?? "",
            "api.path": originalException.path ?? "",
            "api.message": originalException.message ?? "",
          }

          let body = originalException?.__errors?.config?.data || null
          try {
            body = JSON.parse(originalException?.__errors?.config?.data)
          } catch (_) {
            // Do nothing
          }

          event.contexts = {
            ...event.contexts,
            API: {
              url: originalException?.__errors?.config?.url,
              body,
              method: originalException?.__errors?.config?.method,
              statusCode: originalException?.statusCode,
              ...originalException?.errors,
            },
          }

          return event
        }
      }

      return event
    },
  })

  const authInfo = AuthManager.getPlatformAuth()
  if (authInfo)
    Sentry.setUser({ id: authInfo.user.uuid, email: authInfo.user.email })
}

const sentryCreateBrowserRouter = SENTRY_DSN
  ? Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
  : createBrowserRouter

const router = sentryCreateBrowserRouter([
  {
    path: routes.maintenance,
    element: <MaintenanceMode />,
  },
  {
    path: "/",
    element: (
      <MaintenanceMode>
        <SmartBanner />
        <AuthManagerProvider />
      </MaintenanceMode>
    ),
    children: [
      {
        path: routes.profile.asCentre,
        element: (
          <PageWithMeta name="profile">
            <PrivateRoutes platform={Platforms.centerAdmin}>
              <Suspense fallback={<FullPageLoading />}>
                <Profile />
              </Suspense>
            </PrivateRoutes>
          </PageWithMeta>
        ),
      },
      {
        path: routes.profile.asSchool,
        element: (
          <PageWithMeta name="profile">
            <PrivateRoutes platform={Platforms.school}>
              <Suspense fallback={<FullPageLoading />}>
                <Profile />
              </Suspense>
            </PrivateRoutes>
          </PageWithMeta>
        ),
      },
      {
        path: routes.profile.asRecruiter,
        element: (
          <PageWithMeta name="profile">
            <PrivateRoutes platform={Platforms.recruiter}>
              <Suspense fallback={<FullPageLoading />}>
                <Profile />
              </Suspense>
            </PrivateRoutes>
          </PageWithMeta>
        ),
      },
      {
        path: routes.skillProfile.asCentre,
        element: (
          <PageWithMeta name="profile">
            <PrivateRoutes platform={Platforms.centerAdmin}>
              <SkillProfile />
            </PrivateRoutes>
          </PageWithMeta>
        ),
      },
      {
        path: routes.skillProfile.asSchool,
        element: (
          <PageWithMeta name="profile">
            <PrivateRoutes platform={Platforms.school}>
              <SkillProfile />
            </PrivateRoutes>
          </PageWithMeta>
        ),
      },
      {
        path: routes.skillProfile.asRecruiter,
        element: (
          <PageWithMeta name="profile">
            <PrivateRoutes platform={Platforms.recruiter}>
              <SkillProfile />
            </PrivateRoutes>
          </PageWithMeta>
        ),
      },
      {
        path: "posthog-testing",
        element: <PosthogTest />,
      },
      {
        path: routes.misc.fillBlanksTest,
        element: <FillBlanksTest />,
      },
      {
        path: "/",
        element: <GlobalContext />,
        children: [
          {
            path: "/trigger-error",
            element: <SentryErrorTesting />,
          },
          {
            path: routes.logout,
            element: <Logout />,
          },
          {
            path: routes.login,
            element: <Redirect to="/" />,
          },
          {
            path: routes.profile.public,
            element: (
              <PageWithMeta name="profile">
                <Suspense fallback={<FullPageLoading />}>
                  <PublicProfile />
                </Suspense>
              </PageWithMeta>
            ),
          },
          {
            path: routes.pgctlOnboarding.payment,
            element: <PgctlPaymentPage />,
          },
          {
            path: routes.embeddedPayment,
            element: <EmbeddedPayment />,
          },
          {
            path: "/",
            // Don't wrap metadata here
            element: (
              <GrowthspaceRoute
                personal={<AppLayout />}
                suraasaSure={<SuraasaSureAppLayout />}
              />
            ),
            children: [
              {
                path: routes.claimSuraasaPlus,
                element: (
                  <GrowthspaceRoute personal={<ClaimSuraasaPlusPage />} />
                ),
              },
              {
                path: routes.cpat.paymentWithoutSignin,
                element: <CpatPaymentPage />,
              },
              {
                path: routes.suraasaPlus.payment,
                element: <SuraasaPlusPayment />,
              },
              {
                path: routes.suraasaPlus.paymentSuccess,
                element: <SuraasaPlusPaymentSuccessPage />,
              },
              {
                path: routes.skillProfile.public,
                element: <GrowthspaceRoute personal={<SkillProfile />} />,
              },
              // Private Routes: This routes requires user to be authenticated in order to access these routes
              {
                path: "/",
                element: <PrivateRoutes />,
                children: [
                  {
                    path: "/",
                    // Don't wrap metadata here
                    element: <Authentication />,
                    children: [
                      {
                        path: routes.embeddedGoogleForm,
                        element: (
                          <GrowthspaceRoute personal={<EmbeddedGoogleForm />} />
                        ),
                      },
                      {
                        path: routes.gsgCpat,
                        element: <GsgCPAT />,
                      },
                      {
                        path: routes.misc.proctoringDemo,
                        element: (
                          <PageWithMeta name="proctoringDemo">
                            <CpatProctoringTest />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.signUpOnboarding,
                        element: (
                          <PageWithMeta name="signupOnboarding">
                            <SignUpOnboarding />
                          </PageWithMeta>
                        ),
                      },
                      // {
                      //   path: routes.suraasaPlus.questionnaireOnboarding,
                      //   element: (
                      //     <PageWithMeta name="signupOnboarding">
                      //       <SpnyQuestionnaireOnboarding />
                      //     </PageWithMeta>
                      //   ),
                      // },
                      {
                        path: "/suraasa-learner-handbook",
                        element: <Navigate to={routes.learnerHandbook} />,
                      },
                      {
                        path: routes.learnerHandbook,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="learnerHandbook">
                                <LearnerHandbook />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.medStudentCatalog,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="studentCatalog">
                                <StudentCatalog />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.tia,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="tia">
                                <TIA />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: "/dashboard/tia",
                        element: <Redirect to={routes.tia} />,
                      },
                      {
                        path: "/tia",
                        element: <Redirect to={routes.tia} />,
                      },
                      {
                        path: routes.ito,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="ito">
                                <Suspense fallback={<FullPageLoading />}>
                                  <Dashboard />
                                </Suspense>
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: "/cpat/dashboard",
                        element: <Redirect to={routes.cpat.dashboard} />,
                      },
                      {
                        path: routes.cpat.dashboard,
                        element: (
                          <PageWithMeta name="cpat">
                            <CPATOverview />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.cpat.tutorial,
                        element: <CpatAssessmentTour />,
                      },
                      {
                        path: routes.cpat.attempt,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="cpatAttempt">
                                <CpatAssessmentWrapper />
                              </PageWithMeta>
                            }
                            suraasaSure={
                              <PageWithMeta name="cpatAttempt">
                                <CpatAssessmentWrapper />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.cpat.payment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="payment">
                                <CartlessPaymentFlow
                                  productSlug={CPAT_PRODUCT_SLUG}
                                />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.cpat.proctoringReport,
                        element: (
                          <PageWithMeta name="cpat">
                            <CpatProctoringReport />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.subscription,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="payment">
                                <CartlessSubscriptionFlow />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.home,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="home">
                                <Home />
                              </PageWithMeta>
                            }
                            suraasaSure={
                              <PageWithMeta name="home">
                                <SuraasaSureHome />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.masterclasses,
                        element: (
                          <PageWithMeta name="masterclasses">
                            <MasterclassesPage />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.viewMasterclass,
                        element: (
                          <PageWithMeta name="viewMasterclass">
                            <ViewMasterclass />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.applicationForm.uploadPgctlDocuments,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="applicationFormUploadDocuments">
                                <UploadDocuments />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.scheduleInterview,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="scheduleInterview">
                                <ScheduleInterview />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.learning,
                        element: (
                          <PageWithMeta name="learning">
                            <Library />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.attemptAssessment,
                        element: (
                          <PageWithMeta name="attemptAssessment">
                            <AttemptAssessment />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.instructionsITOAssessment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="itoInstructions">
                                <AssessmentInstructions parentSlug="ito" />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.attemptITOAssessment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="itoAssessment">
                                <ITOAssessmentWrapper />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.assessmentResult,
                        element: (
                          <PageWithMeta name="assessmentResult">
                            <AssessmentResult />
                          </PageWithMeta>
                        ),
                      },

                      {
                        path: routes.settings,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="settings">
                                <Settings />
                              </PageWithMeta>
                            }
                            suraasaSure={
                              <PageWithMeta name="settings">
                                <SuraasaSureSettings />
                              </PageWithMeta>
                            }
                          />
                        ),
                        children: [
                          {
                            element: <SettingsRouteElement />,
                            index: true,
                          },
                          {
                            path: routes.accountDetails,
                            element: <AccountDetails />,
                          },
                          {
                            path: routes.privacy,
                            element: <Privacy />,
                          },
                          {
                            path: routes.notificationSettings,
                            element: <NotificationSettings />,
                          },
                          {
                            path: routes.suraasaPlusSettings,
                            element: (
                              <GrowthspaceRoute
                                personal={<SuraasaPlusSettings />}
                              />
                            ),
                          },
                          {
                            path: routes.suraasaPlusPaymentHistory,
                            element: <PaymentHistory />,
                          },
                          {
                            path: routes.suraasaPlusCompareFeat,
                            element: (
                              <GrowthspaceRoute
                                personal={<CompareFeatures />}
                              />
                            ),
                          },
                        ],
                      },
                      {
                        path: routes.cleverAccountLinkCallback,
                        element: <CleverCallback />,
                      },
                      {
                        path: routes.learningModule,
                        element: (
                          <PageWithMeta name="learningModule">
                            <LearningModule />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.learningModuleWithParent,
                        element: (
                          <PageWithMeta name="learningModule">
                            <LearningModule />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.parentItem,
                        // Can't wrap meta here. Because it is dependent on page URL.
                        // It is handled inside
                        element: <Qualification />,
                        children: [
                          {
                            element: <Navigate to="overview" replace />,
                            index: true,
                          },
                          {
                            path: routes.parentItemOverview,
                            element: <QualificationOverview />,
                          },
                          {
                            path: routes.parentItemAssessments,
                            element: <QualificationAssessments />,
                          },
                          {
                            path: routes.parentItemCertificates,
                            element: <QualificationCertificates />,
                          },
                          {
                            path: routes.parentItemClasses,
                            element: <QualificationClasses />,
                          },
                          {
                            path: routes.parentItemAnalytics,
                            element: <LearnerAnalytics />,
                          },
                          {
                            path: routes.parentItemResources,
                            element: <AdditionalResources qualification />,
                          },
                          {
                            path: routes.parentItemGradebook,
                            element: <GradeBook />,
                          },
                          {
                            path: routes.parentItemAbout,
                            element: <QualificationAbout />,
                          },
                          // {
                          //   path: routes.parentItemLeaderboard,
                          //   element: <Leaderboard />,
                          // },
                        ],
                      },
                      {
                        path: routes.course,
                        element: (
                          <PageWithMeta name="course">
                            <Course />
                          </PageWithMeta>
                        ),
                        children: [
                          {
                            element: <Navigate to="overview" replace />,
                            index: true,
                          },
                          {
                            path: "/course/:slug/overview",
                            element: <CourseOverview />,
                          },
                          {
                            path: "/course/:slug/classes",
                            element: <CourseClassesRoute />,
                          },
                          {
                            path: routes.courseAssignments,
                            element: (
                              <PageWithMeta name="assignments">
                                <CourseAssignments />
                              </PageWithMeta>
                            ),
                          },
                          {
                            path: "/course/:slug/assessments",
                            element: <CourseAssessments />,
                          },
                          {
                            path: "/course/:slug/resources",
                            element: <AdditionalResources course />,
                          },
                          {
                            path: "/course/:slug/analytics",
                            element: <LearnerAnalytics />,
                          },
                          {
                            path: "/course/:slug/about",
                            element: <CourseAbout />,
                          },
                        ],
                      },
                      {
                        path: routes.parentItemCourse,
                        element: (
                          <PageWithMeta name="course">
                            <Course />
                          </PageWithMeta>
                        ),
                        children: [
                          {
                            element: <Navigate to="overview" replace />,
                            index: true,
                          },
                          {
                            path: `${routes.parentItemCourse}/overview`,
                            element: <CourseOverview />,
                          },
                          {
                            path: `${routes.parentItemCourse}/classes`,
                            element: <CourseClassesRoute />,
                          },
                          {
                            path: `${routes.parentItemCourse}/assignments`,
                            element: <CourseAssignments />,
                          },
                          {
                            path: `${routes.parentItemCourse}/assessments`,
                            element: <CourseAssessments />,
                          },
                          {
                            path: `${routes.parentItemCourse}/resources`,
                            element: <AdditionalResources course />,
                          },
                          {
                            path: `${routes.parentItemCourse}/analytics`,
                            element: <LearnerAnalytics />,
                          },
                          {
                            path: `${routes.parentItemCourse}/about`,
                            element: <CourseAbout />,
                          },
                        ],
                      },
                      {
                        path: routes.notifications,
                        element: (
                          <PageWithMeta name="notifications">
                            <Notifications />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: "/ito",
                        element: <Redirect to={routes.ito} />,
                      },
                      {
                        path: "/",
                        element: <Redirect to={routes.home} />,
                      },
                      {
                        path: "/ito-dashboard",
                        element: <Redirect to={routes.ito} />,
                      },
                      {
                        path: "/library",
                        element: <Redirect to={routes.learning} />,
                      },
                      {
                        path: routes.old.assignments,
                        element: <Redirect to={routes.learning} />,
                      },
                      {
                        path: routes.old.assessments,
                        element: <Redirect to={routes.learning} />,
                      },
                      {
                        path: routes.old.home,
                        element: <Redirect to={routes.home} />,
                      },
                      {
                        path: routes.old.ito,
                        element: <Redirect to={routes.ito} />,
                      },
                      {
                        path: routes.old.orders,
                        element: <Redirect to={routes.orders} />,
                      },
                      {
                        path: routes.old.payment,
                        element: <Redirect to={routes.payment} />,
                      },
                      {
                        path: routes.skillProfile.public,
                        element: <SkillProfile />,
                      },
                      {
                        path: routes.aiTools.home,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiTools">
                                <AItools />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.lessonPlan,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiLessonPlanGenerator">
                                <Generator type={ToolType.lessonPlan} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.rubrics,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiRubricsGenerator">
                                <Generator type={ToolType.rubrics} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.quiz,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiQuizGenerator">
                                <Generator type={ToolType.quiz} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.handout,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiHandoutGenerator">
                                <Generator type={ToolType.handout} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.narration,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiNarrationGenerator">
                                <Generator type={ToolType.narration} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.subjectiveAssessment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiSubjectiveAssessmentGenerator">
                                <Generator
                                  type={ToolType.subjectiveAssessment}
                                />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.assignment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiAssignmentGenerator">
                                <Generator type={ToolType.assignment} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.activityPlanner,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiActivityPlannerGenerator">
                                <Generator type={ToolType.activityPlanner} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.videoSummary,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiVideoSummaryGenerator">
                                <Generator type={ToolType.videoSummary} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.aiTools.unitPlanner,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="aiUnitPlanGenerator">
                                <Generator type={ToolType.unitPlanner} />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      // Even though these routes are supposedly "public", They still require authentication.
                      // Business use case: You need to have an account on Suraasa to view someone's skill portfolio.
                      {
                        path: routes.skillProfile.public,
                        element: (
                          <GrowthspaceRoute personal={<SkillProfile />} />
                        ),
                      },
                      {
                        path: routes.profile.self,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="profile">
                                <Suspense fallback={<FullPageLoading />}>
                                  <Profile />
                                </Suspense>
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.ito2022,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <Suspense
                                fallback={
                                  <div className="flex justify-center p-5">
                                    Loading...
                                  </div>
                                }
                              >
                                <ITO />
                              </Suspense>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.assignment,
                        element: (
                          <PageWithMeta name="viewAssignment">
                            <Suspense
                              fallback={
                                <div className="flex justify-center p-5">
                                  Loading Skill Evidence (Assignment)...
                                </div>
                              }
                            >
                              <Assignments />
                            </Suspense>
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.submission,
                        element: (
                          <PageWithMeta name="submission">
                            <AssignmentResult />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.mySchedule,
                        element: (
                          <PageWithMeta name="schedule">
                            <Suspense
                              fallback={
                                <div className="flex justify-center p-5">
                                  Loading Schedule...
                                </div>
                              }
                            >
                              <Schedule />
                            </Suspense>
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.discussions,
                        element: (
                          <PageWithMeta name="discussions">
                            <Discussions />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: "/discussions",
                        element: <Navigate to={routes.discussions} replace />,
                      },
                      {
                        path: routes.certificates,
                        element: (
                          <PageWithMeta name="certificates">
                            <MyCertificates />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: routes.orders,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="orders">
                                <Orders />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.payment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="payment">
                                <Payment />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.retryPayment,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="payment">
                                <RetryPaymentPage />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      {
                        path: routes.orderDetailsPage,
                        element: (
                          <GrowthspaceRoute
                            personal={
                              <PageWithMeta name="orderDetails">
                                <OrderDetails />
                              </PageWithMeta>
                            }
                          />
                        ),
                      },
                      // {
                      //   path: routes.orderPaymentPlan,
                      //   element: <HassleFreePaymentPlan />,
                      // },
                      {
                        path: routes.discussionDetail,
                        element: (
                          <PageWithMeta name="viewDiscussion">
                            <DiscussionDetailPage />
                          </PageWithMeta>
                        ),
                      },
                      {
                        path: "/discussions/:id",
                        element: <RedirectToNewDiscussion />,
                      },
                      {
                        path: "/*",
                        element: (
                          <PageWithMeta name="pageNotFound">
                            <Suspense
                              fallback={
                                <div className="flex justify-center p-5">
                                  Loading...
                                </div>
                              }
                            >
                              <ErrorPage errorStatus={404} />
                            </Suspense>
                          </PageWithMeta>
                        ),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          // {
          //   path: "/misc/captcha",
          //   element: <CaptchaTest />,
          // },
          // {
          //   path: routes.misc.proctoringDemo,
          //   element: (
          //     <PageWithMeta name="proctoringDemo">
          //       <ProctoringDemo />
          //     </PageWithMeta>
          //   ),
          // },
          // {
          //   path: routes.misc.components,
          //   element: (
          //     <PageWithMeta name="components">
          //       <ComponentsTest />
          //     </PageWithMeta>
          //   ),
          // },
          {
            path: "/*",
            element: (
              <PageWithMeta name="pageNotFound">
                <Suspense
                  fallback={
                    <div className="flex justify-center p-5">Loading...</div>
                  }
                >
                  <ErrorPage errorStatus={404} />
                </Suspense>
              </PageWithMeta>
            ),
          },
        ],
      },
    ],
  },
])

function RedirectToNewDiscussion() {
  const { id } = useParams() as { id: string }
  return <Navigate to={routes.discussionDetail.replace(":id", id)} replace />
}

const App = () => {
  const { direction } = useDOMDirection(<App />)

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        /**
         * We don't want failed requests to be retried by default
         * We can enable this on a per-API basis
         */
        retry: false,
      },
    },
  })

  return (
    <PostHogProviderWrapper>
      <ThemeProvider theme={{ ...theme, direction }}>
        <QueryClientProvider client={queryClient}>
          <ActionAlertProvider>
            <RouterProvider router={router} />
            <ToastProvider />
          </ActionAlertProvider>
          {/* {import.meta.env.MODE === "development" && <ReactQueryDevtools />} */}
        </QueryClientProvider>
      </ThemeProvider>
    </PostHogProviderWrapper>
  )
}

export default App
